<ng-container>
  <!-- Header Section -->
  <div class="flex items-center justify-between mb-4">
    <div>
      <h2 class="text-xl font-medium text-[#141437] dark:text-white backdrop-blur-lg tracking-tight">
        Update Role:
        <span class="opacity-80 font-normal">{{ roleName() }}</span>
      </h2>
      <p class="text-slate-500 dark:text-slate-400 text-sm mt-1">
        Manage access permissions for this role
      </p>
    </div>
    <div class="flex gap-3">
      <app-button [variant]="'defaultBorder'" routerLink="/app/prism/menu-roles/manage-roles" className="!px-6">
        Back
      </app-button>
      <app-button (click)="saveChanges()" [disabled]="isLoading()" [class.opacity-50]="isLoading()"
        [variant]="'default'" className="!px-6 shadow-lg shadow-primary/20">
        Update
      </app-button>
    </div>
  </div>

  <!-- Main Card -->
  <div class="card-bg rounded-2xl shadow-sm border border-slate-200 dark:border-white/5 overflow-hidden">
    <!-- Toolbar -->
    <div
      class="p-6 border-b border-slate-200 dark:border-white/5 flex flex-wrap justify-between items-center gap-4 bg-slate-50/50 dark:bg-white/[0.02]">
      <div class="relative max-w-md w-full group">
        <app-icon name="search" [size]="18"
          class="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-primary transition-colors"></app-icon>
        <input (input)="onSearch($event)" type="text" placeholder="Search menu items..."
          class="w-full pl-10 pr-4 py-2.5 bg-white dark:bg-slate-900/50 border border-slate-200 dark:border-white/10 rounded-xl focus:outline-none focus:ring-1 focus:ring-slate-700/50 dark:focus:ring-purple-700 text-sm transition-all text-slate-700 dark:text-slate-200" />
      </div>

      <!-- Legend -->
      <!-- <div
        class="flex items-center gap-4 text-xs text-slate-500 dark:text-slate-400"
      >
        <div class="flex items-center gap-2">
          <div
            class="w-3 h-3 rounded bg-purple-600/20 border border-purple-600/50"
          ></div>
          <span>Has Access</span>
        </div>
        <div class="flex items-center gap-2">
          <div
            class="w-3 h-3 rounded border border-slate-300 dark:border-slate-600"
          ></div>
          <span>No Access</span>
        </div>
      </div> -->
    </div>

    <!-- Table -->
    <div class="overflow-x-auto relative">
      <table class="w-full text-left text-sm table-fixed">
        <thead>
          <tr class="bg-slate-50/80 dark:bg-white/[0.03] border-b border-slate-200 dark:border-white/5">
            <th class="px-8 py-5 font-medium text-slate-600 dark:text-slate-300 w-[45%]">
              Menu Item
            </th>
            <!-- <th
              class="px-6 py-5 font-medium text-slate-600 dark:text-slate-300 w-[40%]"
            >
              Restriction Type
            </th> -->
            <th class="px-6 py-5 font-medium text-slate-600 dark:text-slate-300 text-center w-[15%]">
              Access
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100 dark:divide-white/5">
          <ng-container *ngFor="let product of menuItems()">
            <!-- PRODUCT ROW -->
            <tr class="group hover:bg-slate-50 dark:hover:bg-white/[0.02] transition-colors cursor-pointer select-none"
              (click)="toggleExpand(product)">
              <td class="px-8 py-4 w-[45%]">
                <div class="flex items-center gap-3">
                  <div
                    class="p-1 rounded-md bg-slate-100 dark:bg-white/10 text-slate-500 dark:text-slate-400 group-hover:bg-purple-600/10 group-hover:text-purple-600 transition-colors">
                    <app-icon [name]="product.expanded ? 'chevronDown' : 'chevronRight'" [size]="16"></app-icon>
                  </div>
                  <span class="font-medium text-slate-800 dark:text-slate-100 text-base">{{ product.name }}</span>
                </div>
              </td>
              <td class="px-6 py-4 w-[40%]"></td>
              <td class="px-6 py-4 w-[15%]"></td>
            </tr>

            <!-- ROUTES (Children of Product) -->
            <tr *ngIf="product.children?.length > 0">
              <td colspan="3" class="p-0 border-0">
                <div class="overflow-hidden" [@expandCollapse]="
                    product.expanded ? 'expanded' : 'collapsed'
                  ">
                  <table class="w-full table-fixed">
                    <tbody class="divide-y divide-slate-100 dark:divide-white/5">
                      <ng-container *ngFor="let route of product.children">
                        <!-- ROUTE ROW -->
                        <tr
                          class="hover:bg-slate-50 dark:hover:bg-white/[0.02] transition-colors border-b border-slate-50 dark:border-white/5 last:border-0"
                          (click)="toggleExpand(route)">
                          <td class="px-8 py-3.5 pl-16 relative w-[45%]">
                            <!-- Tree Connector Line -->
                            <div class="absolute left-[50px] top-0 bottom-0 w-px bg-slate-200 dark:bg-white/5"></div>
                            <div class="absolute left-[50px] top-1/2 w-4 h-px bg-slate-200 dark:bg-white/5"></div>

                            <div class="flex items-center gap-3 cursor-pointer">
                              <ng-container *ngIf="
                                  route.children?.length > 0;
                                  else noChildren
                                ">
                                <div class="p-0.5 rounded hover:bg-slate-200 dark:hover:bg-white/10 transition-colors">
                                  <app-icon [name]="
                                      route.expanded
                                        ? 'chevronDown'
                                        : 'chevronRight'
                                    " [size]="14" class="text-slate-400 dark:text-slate-500"></app-icon>
                                </div>
                              </ng-container>
                              <ng-template #noChildren>
                                <span class="w-4"></span>
                              </ng-template>
                              <span class="text-slate-700 dark:text-slate-300 font-medium">{{ route.name }}</span>
                            </div>
                          </td>
                          <!-- <td class="px-6 py-3.5 w-[40%] text-left">
                            <span
                              class="text-slate-400 dark:text-slate-500 text-xs italic flex items-center gap-1.5"
                            >
                              {{ route.restriction }}
                            </span>
                          </td> -->

                          <td class="px-6 py-3.5 text-center w-[15%]">
                            <div class="flex justify-center" (click)="$event.stopPropagation()">
                              <input (change)="updateItemAccess(route, $event)" type="checkbox"
                                (click)="$event.stopPropagation()" [checked]="route.hasAccess"
                                class="w-5 h-5 rounded-md border-slate-300 dark:border-slate-600 text-cyan-600 focus:ring-cyan-600/20 bg-transparent cursor-pointer transition-all checked:bg-cyan-600 checked:border-cyan-600" />
                            </div>
                          </td>

                          <td></td>
                        </tr>

                        <!-- SUB MENUS (Children of Route) -->
                        <tr *ngIf="route.children?.length > 0">
                          <td colspan="3" class="p-0 border-0">
                            <div class="overflow-hidden" [@expandCollapse]="
                                route.expanded ? 'expanded' : 'collapsed'
                              ">
                              <table class="w-full table-fixed">
                                <tbody>
                                  <tr *ngFor="let sub of route.children"
                                    class="hover:bg-slate-50 dark:hover:bg-white/[0.02] border-b border-slate-50 dark:border-white/5 last:border-0">
                                    <td class="px-8 py-3 pl-24 relative w-[45%]">
                                      <!-- Tree Connector Line -->
                                      <div
                                        class="absolute left-[50px] top-0 bottom-0 w-px bg-slate-200 dark:bg-white/5">
                                      </div>
                                      <!-- Extended connector for sub level -->
                                      <div
                                        class="absolute left-[82px] top-0 bottom-1/2 w-px bg-slate-200 dark:bg-white/5">
                                      </div>
                                      <div class="absolute left-[82px] top-1/2 w-4 h-px bg-slate-200 dark:bg-white/5">
                                      </div>

                                      <span class="text-slate-600 dark:text-slate-400 text-sm">{{ sub.name }}</span>
                                    </td>
                                    <!-- <td class="px-6 py-3 w-[40%] text-left">
                                      <span
                                        class="text-slate-400 dark:text-slate-600 text-xs italic"
                                        >{{ sub.restriction }}</span
                                      >
                                    </td> -->
                                    <td class="px-6 py-3 text-center w-[15%]">
                                      <div class="flex justify-center">
                                        <input type="checkbox" [checked]="sub.hasAccess" (change)="
                                            updateItemAccess(sub, $event, route)
                                          "
                                          class="w-4.5 h-4.5 rounded border-slate-300 dark:border-slate-600 text-cyan-600 focus:ring-cyan-600/20 bg-transparent cursor-pointer transition-all checked:bg-cyan-600 checked:border-cyan-600" />
                                      </div>
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      @if(isLoading()){
      <div class="h-[50vh]">
        <app-individual-toaster></app-individual-toaster>
      </div>
      } @if(!isLoading() && menuItems().length === 0){
      <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
        <svg class="w-16 h-16 mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4">
          </path>
        </svg>
        <p class="text-lg font-medium">No data available</p>
        <p class="text-sm mt-1">Data will appear here when available</p>
      </div>
      }
    </div>
  </div>
</ng-container>